import getBlockById from 'services/apiHelpers/getBlockById';
import { findByKeyVal_V2 } from 'services/findByKeyVal';
import getTopics from 'services/apiHelpers/getTopics';
import getStore from 'services/getStore';
import {
  addTopicPortalMedia as _addTopicPortalMedia_,
  removeTopicPortalMedia as _removeTopicPortalMedia_,
} from 'factories/interactions/topicportal';
import { setBlockAction } from 'actions/setBlockAction';
import { setBlocksAction } from 'actions/setBlocksAction';
import setNewBlockNewTree from 'services/apiHelpers/setNewBlockNewTree';
import { Block } from 'factories/block';

type TopicSidId = {
  topicSId: number;
  topicId: string;
};

const addTopicPortalMedia = (topicPortalContainerBlock, index, props) => {
  const [newBlock, newTree] = _addTopicPortalMedia_(
    topicPortalContainerBlock,
    index,
    props
  );

  if (newBlock === topicPortalContainerBlock) {
    return;
  }

  const store = getStore();

  if (newTree) {
    setNewBlockNewTree(newTree, newBlock, store, setBlocksAction);
  } else {
    store.dispatch(setBlockAction(newBlock));
  }
};

const removeTopicPortalMedia = (topicPortalContainerBlock, index) => {
  const [newBlock, newTree] = _removeTopicPortalMedia_(
    topicPortalContainerBlock,
    index
  );

  if (newBlock === topicPortalContainerBlock) {
    return;
  }

  const store = getStore();

  if (newTree) {
    setNewBlockNewTree(newTree, newBlock, store, setBlocksAction);
  } else {
    store.dispatch(setBlockAction(newBlock));
  }

  // console.warn('removeTopicPortalMedia ???');
};

export const updateTopicPortalMedia = (topics, blockId) => {
  const getTopicPortalContainerBlock = () => {
    return findByKeyVal_V2(blockId, 'type', 'TopicPortalContainer');
  };

  const getTopicPortalContainerBlockChildrenData = () => {
    return (getTopicPortalContainerBlock()?.children as []).map(
      (child: Block) => {
        const block = getBlockById(child.id);
        return block?.props as TopicSidId;
      }
    );
  };

  const addMedia = () => {
    const topicPortalContainerBlockChildrenData = getTopicPortalContainerBlockChildrenData();

    topics.forEach((t, index) => {
      if (
        !topicPortalContainerBlockChildrenData.some(entry => {
          const { topicSId, topicId } = entry;

          return topicSId === t?.props?.sId || topicId === t?.id;
        })
      ) {
        //
        console.log('ADDING TOPIC PORTAL MEDIA :', {
          topicId: t?.id,
          topicSId: t?.props?.sId,
        });

        addTopicPortalMedia(getTopicPortalContainerBlock(), index, {
          topicId: t?.id,
          topicSId: t?.props?.sId,
        });
      }
    });
  };

  const removeMedia = () => {
    getTopicPortalContainerBlockChildrenData().forEach((props: any, index) => {
      const { topicSId, topicId } = props;

      const topicIdentifiers = topics.map(t => {
        return t?.props?.sId || t?.id;
      });

      if (!topicIdentifiers?.includes(topicSId || topicId)) {
        //
        console.log(
          'REMOVING TOPIC PORTAL MEDIA :',
          topicIdentifiers,
          { topicSId, topicId },

          topicSId
        );

        removeTopicPortalMedia(getTopicPortalContainerBlock(), index);
      }
    });
  };

  return {
    addMedia,
    removeMedia,
  };
};
